const $ = require("jquery");
import Vue from "vue";
import Mailbox from "../../vue/components/Mailbox";

let vwidth = $(window).width();
let $userbutton = $(".userbutton");
let $useraccount = $(".useraccount");
let $modal = $("#modal");
let $modalwrapper = $("#modal-wrapper");
let $modalcontent = $("#modal-content");
let $main = $(".main");
let $content = $(".content");
let sidewidgetopen = false;

$(window).resize(function () {
  handleModal();
});

handleModal();

$("#modal-close").click(function () {
  $modal.addClass("closed");
});

$userbutton.click(function () {
  if ($(this).data("ebu") === 0) {
    if (vwidth < 768) {
      mobileUseraccount(vwidth, $(this));
    } else {
      let lib = $(this).data("lib");
      if (lib === 0) {
        deskShowUseraccount(vwidth);
        $(this).data("lib", 1);
      }
      if (lib === 1) {
        deskHideUseraccount();
        $(this).data("lib", 0);
      }
    }
  }
  if ($(this).data("ebu") === 1) {
    window.location.href = "/brief-hochladen";
  }
});

function deskShowUseraccount(width) {
  let ubw = $userbutton.width();
  let ubh = $userbutton.height();
  let ubl = $userbutton.offset().left;
  let ubc = ubw / 2 + ubl;
  let uaw = $useraccount.width();
  let ual = ubc - uaw / 2;

  $useraccount.css("top", $userbutton.offset().top + ubh); // + 8
  let uar = ual + uaw;

  if (uar > width) {
    let diff = uar - width;
    ual = ual - diff - 10;
    $(".useraccount__arrow").css("left", diff + 10);
  }

  $useraccount.css({ left: ual, height: 468 });
}

function deskHideUseraccount() {
  $useraccount.css({ height: 0 });
}

function mobileUseraccount(width, button) {
  if (button.hasClass("useraccount--show")) {
    closeSideUser(button);
  } else {
    openSideUser(button, width);
  }
}

function handleModal() {
  if ($modal.length) {
    showModal();
  }
}

function showModal() {
  let windowwidth = $(window).width();
  if (
    $modalcontent.data("mobil-width") !== undefined &&
    $modalcontent.data("desk-width") !== undefined
  ) {
    let modalcontenwidth = 0;
    if (windowwidth < 790) {
      modalcontenwidth = $modalcontent.data("mobil-width");
    } else {
      modalcontenwidth = $modalcontent.data("desk-width");
    }
    let modalwrapperwidth = modalcontenwidth + 40;
    $modalwrapper.css("width", modalwrapperwidth);
    $modalcontent.css("width", modalcontenwidth);
    if (windowwidth > modalwrapperwidth) {
      $modalwrapper.css("margin-left", -(modalwrapperwidth / 2));
    }
  }
  if (
    $modalcontent.data("mobil-height") !== undefined &&
    $modalcontent.data("desk-height") !== undefined
  ) {
    let modalcontenheight = 0;
    if (windowwidth < 790) {
      modalcontenheight = $modalcontent.data("mobil-height");
    } else {
      modalcontenheight = $modalcontent.data("desk-height");
    }
    let modalwrapperheight = modalcontenheight + 40;
    $modalwrapper.css("height", modalwrapperheight);
    $modalcontent.css("height", modalcontenheight);
    if ($(window).height() > modalwrapperheight) {
      $modalwrapper.css("margin-top", -(modalwrapperheight / 2));
    }
  }
}

function openSideUser(button, width) {
  button.addClass("useraccount--show");
  let offset = width - 62;
  $useraccount.css("width", offset);
  $(".useraccount__arrow").css("width", offset);
  $(".useraccount__logo").css("width", offset);
  $main.css({ "margin-left": -offset, width: width });
  $mainnav.css({ position: "fixed", "z-index": 9999999, "box-shadow": "none" });
  if ($(window).scrollTop() < mainnavHeight) {
    console.log("set content top padding by user");
    $content.css({ "padding-top": "50px" });
  }
  $content.css({ width: width });
  $("body").css("overflow", "hidden");
  sidewidgetopen = true;
}

function closeSideUser(button) {
  button.removeClass("useraccount--show");
  $(".useraccount__arrow").css("width", 0);
  $useraccount.css("width", 0);
  $main.css({ "margin-left": 0, width: "auto" });
  $(".useraccount__newuser").css("bottom", 0);
  sidewidgetopen = false;
}

if (typeof configdata !== "undefined" && configdata.app === "mailbox") {
  new Vue({
    components: { Mailbox },
    props: {
      configdata: configdata
    },
    template: "<Mailbox/>"
  }).$mount("#app");
}

$.each($("img.ebrief-tooltip"), function () {
  $(this).tipso({
    maxWidth: 300,
    width: true,
    contentElementId: "tooltip-content-id-" + $(this).data("tipso-key"),
    imageDir: "/build/images/",
    imageHover: "info-circle-green.svg",
    imageOut: "info-circle-darkgrey.svg"
  });
});
